import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useServiceList() {
    const toast = useToast();
    const refListTable = ref(null);
    const tableColumns = [
        { key: 'id', label: 'ID', sortable: false },
        { key: 'name',label:'Service Name', sortable: false },
        { key: 'actions' },
    ];
    const perPage = ref(10);
    const serviceData = ref([])
    const totals = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totals.value,
        }
    })

    const refetchData = () => {
        refListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    });

    const fetchData = (ctx, callback)=>{
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch('app-phone-book/fetchPhonebookServices', {
            perpage: perPage.value,
            offset: offset,
            order_by: 'id DESC'
        })
        .then(response => {
            serviceData.value = response.data.data
            totals.value = response.data.total
            callback(serviceData.value)
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                title: "Error fetching PhoneBook' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                },
            })
        })
    }

    const deleteData = (id) => {
        store.dispatch('app-phone-book/detelePhoneBookService', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            refetchData();
        }).catch(()=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Error Delete Service",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                },
            })
        })
    }

    return {
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totals,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
        deleteData,
        refetchData,
        serviceData,
    }
}